import { useState } from "react";
import { Typography } from "@mui/material";
import Paper from "apollo-react/components/Paper";
import Modal from "apollo-react/components/Modal";
import Doctor2 from "apollo-react-icons/Doctor2";
import Calendar from "apollo-react-icons/Calendar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "apollo-react/components/Button";
import "../../../common/Reviews_Cards/styles.css";

const DraftCard = ({ draft, onDelete }) => {
  const { t } = useTranslation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const formatDate = (timestamp) => {
    const d = new Date(timestamp);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear().toString().slice(-2);
    const hours = d.getHours().toString().padStart(2, "0");
    const minutes = d.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    onDelete(draft.draftId);
  };

  const handleCloseModal = () => {
    setShowDeleteModal(false);
  };

  const navigateTo = `/customer/requests/new-requests/view/${draft.workflowVersionId}?draftId=${encodeURIComponent(draft.draftId)}${draft.draftName ? `&request_name=${encodeURIComponent(draft.draftName)}` : ''}`;

  return (
    <Paper className="trial-card">
      <div className="header-container">
        <div className="header-left-container">
          <span className="status-badge submitted">
            {t('Draft')}
          </span>
        </div>
        <Button
          variant="secondary"
          size="medium"
          onClick={handleDeleteClick}
          style={{ marginLeft: 'auto', border: '1px solid #D9D9D9' }}
        >
          {t('delete')}
        </Button>
      </div>

      <div className="info-row">
        <div className="info-label">
          <span className="icon-wrapper">
            <Doctor2 />
          </span>
          <Typography className="row-text-header" variant="body2">
            {t('Request Name')}:
          </Typography>
        </div>
        <Typography className="row-text-data" variant="body2">
          {draft.draftName}
        </Typography>
      </div>

      <div className="info-row">
        <div className="info-label">
          <span className="icon-wrapper">
            <Doctor2 />
          </span>
          <Typography className="row-text-header" variant="body2">
            {t('Workflow')}:
          </Typography>
        </div>
        <Typography className="row-text-data" variant="body2">
          {draft.formName || t('N/A')}
        </Typography>
      </div>

      <div className="info-row">
        <div className="info-label">
          <span className="icon-wrapper">
            <Calendar />
          </span>
          <Typography className="row-text-header" variant="body2">
            {t('draftedAt')}:
          </Typography>
        </div>
        <Typography className="row-text-data" variant="body2">
          {formatDate(draft.timestamp)}
        </Typography>
      </div>

      <div className="view-details">
        <Link to={navigateTo} className="link-style">
          {t('View Details')}
        </Link>
      </div>

      <Modal
        open={showDeleteModal}
        onClose={handleCloseModal}
        message={t('deleteDraftConfirm')}
        buttonProps={[
          {
            label: t('Cancel'),
            onClick: handleCloseModal,
            variant: 'secondary'
          },
          {
            label: t('Confirm'),
            onClick: handleConfirmDelete,
            variant: 'primary',
            status: 'danger'
          }
        ]}
        hideHeader
      />
    </Paper>
  );
};

export default DraftCard;

